/* src/app/modules/notification/notification.component.scss */
.notifications {
  position: fixed;
  top: 7%;
  right: 1%;
  z-index: 1000;
  min-width: 400px;
  max-width: 400px;
}
.notifications .notification {
  margin: 5px;
  border-radius: 5px;
  color: #fff;
  overflow: hidden;
}
.notifications .notification .title {
  background: rgba(0, 0, 0, 0.6);
  padding-left: 10px;
  font-weight: bold;
}
.notifications .notification .title .lbl {
  display: inline-block;
  width: 85%;
}
.notifications .notification .title .btnX {
  display: inline-block;
  width: 15%;
}
.notifications .notification .message {
  background: rgba(0, 0, 0, 0.4);
  padding: 10px;
  max-height: 200px;
  overflow-y: auto;
}
.notifications .notification.Informativo {
  background-color: rgba(189, 189, 189, 0.9);
}
.notifications .notification.Exito {
  background-color: rgba(27, 158, 119, 0.9);
}
.notifications .notification.Alerta {
  background-color: rgba(217, 95, 2, 0.9);
}
.notifications .notification.Error {
  background-color: rgba(246, 71, 71, 0.9);
}
/*# sourceMappingURL=notification.component.css.map */
